import { FC } from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';
import { SortParams } from '@/components/exchange/orders/MarketOrderTable';

interface TableHeadingSortingProps {
    title: string;
    id?: SortParams;
    current?: SortParams;
    onSortClick?: (id: SortParams) => void;
    isAscending?: boolean;
}

export const TableHeadingSorting: FC<TableHeadingSortingProps> = ({ title, id, current, onSortClick, isAscending }) => {
    const sort = () => id && onSortClick && onSortClick(id);
    return (
        <div className="flex items-center justify-center cursor-pointer text-grey-20">
            <span className="t__caption--c1" onClick={sort}>
                {title}
            </span>
            {!!onSortClick ? (
                !isAscending && id === current ? (
                    <AiOutlineArrowDown size={'12px'} onClick={sort} />
                ) : isAscending && id === current ? (
                    <AiOutlineArrowUp size={'12px'} onClick={sort} />
                ) : (
                    <div className="w-3 h-3" />
                )
            ) : null}
        </div>
    );
};
